import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import Config from '../../utils/config.service';
import BusinessRestServices from '../../services/business-rest.service';
import ServiceRestServices from '../../services/service-rest.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import RoutingService from '../../services/routing.service';
import moment from 'moment';

@Component({
	standalone: true,
	selector: 'mental-health-services',
	templateUrl: './mental-health-services.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, FormsModule ]
})
export default class MentalHealthServicesView implements OnInit {
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.isInitialized = false;
		this.routingService.validateAccess('booking')
			.then(() => {
				var rawData: any = window.sessionStorage.getItem(this.config.getBookingConfig().Instant.STORAGE_KEY);
				var booking: any = rawData ? JSON.parse(rawData) : {};
				var origin: any = this.angularRoutingHelperService.getQueryParam('origin');

				if (booking && booking.service) {
					this.onResolve();
				} else {
					if (!origin) {
						var userSession = this.session.getSession();
						origin = (userSession && userSession.user && userSession.user.origin)
							? userSession.user.origin
							: 'minudoc.ee';
					}

					var params: any = {
						origin: origin
					};
					this.businessRestServices.getOnDemandSettings(params, (settings) => {
						this.vm.allOndemandSettings = settings;
						this.onResolve();
					});
				}
			});
	}
	
	onResolve() {
		this.vm.user = this.session.getSession().user;
		this.vm.origin = this.session.getSession().user.origin;
		this.vm.isSiffi = (this.vm.origin == 'siffi.com');
		this.vm.textColor = (this.vm.isSiffi ? '' : 'c-text--gray');
		
		this.vm.title = this.angularFilterHelperService.translate('Booking.Instant.Choose_Action');
		
		this.vm.settings = this.vm.allOndemandSettings.filter((item) => {
			return item.subcategory === 'GENERAL_MEDICAL_PRACTICE' && item.furtherSubcategory === 'MENTAL_CHECK';
		})[0] || {};
		
		var timezoneOffsetHours: any = 0;
		if (!this.vm.isSiffi) {
			var isDaylightSavingTime: any = moment().isDST();
			timezoneOffsetHours = isDaylightSavingTime ? 3 : 2;
		}
		var startTimeHours: any = (24 + this.vm.settings.startTimeInHours + timezoneOffsetHours) % 24;
		var startTime: any = ('0' + startTimeHours).slice(-2) + ':00';
		var endTimeHours: any = (24 + this.vm.settings.endTimeInHours + timezoneOffsetHours) % 24;
		var endTime: any = ('0' + endTimeHours).slice(-2) + ':00';
		var weekendStartTimeHours, weekendStartTime, weekendEndTimeHours, weekendEndTime;
		if (this.vm.settings.weekendStartTimeInHours && this.vm.settings.weekendEndTimeInHours) {
			weekendStartTimeHours = (24 + this.vm.settings.weekendStartTimeInHours + timezoneOffsetHours) % 24;
			weekendStartTime = ('0' + weekendStartTimeHours).slice(-2) + ':00';
			weekendEndTimeHours = (24 + this.vm.settings.weekendEndTimeInHours + timezoneOffsetHours) % 24;
			weekendEndTime = ('0' + weekendEndTimeHours).slice(-2) + ':00';
		}
		var timeZoneInfo: any = this.angularFilterHelperService.translate('Booking.Instant.Info_Time_Zone_1');
		if (origin == 'minudoc.fi') {
			timeZoneInfo = this.angularFilterHelperService.translate('Booking.Instant.Info_Time_Zone_2');
		} else if (origin == 'minudoc.lv') {
			timeZoneInfo = this.angularFilterHelperService.translate('Booking.Instant.Info_Time_Zone_3');
		} else if (origin == 'minudoc.lt') {
			timeZoneInfo = this.angularFilterHelperService.translate('Booking.Instant.Info_Time_Zone_4');
		} else if (origin == 'minudoc.pl') {
			timeZoneInfo = this.angularFilterHelperService.translate('Booking.Instant.Info_Time_Zone_5');
		}
		
		if (typeof this.vm.settings.endTimeInHours === 'number') {
			this.setInstantServiceAvailableTime(startTime, endTime, timeZoneInfo, weekendStartTime, weekendEndTime);
		}
		
		this.vm.goToConciergeFlow = this.goToConciergeFlow;
		this.vm.goToFollowUpHistory = this.goToFollowUpHistory;
		this.vm.goToMyWellbeingProfile = this.goToMyWellbeingProfile;
		this.vm.goToMeditationActivation = this.goToMeditationActivation;
		this.vm.goToAudiobooks = this.goToAudiobooks;
		
		this.vm.isInitialized = true;
	}
	
	setInstantServiceAvailableTime(startTime, endTime, timeZoneInfo, weekendStartTime, weekendEndTime) {
		if (this.vm.origin == 'siffi.com') {
			if (this.vm.settings.workingDaysOnly) {
				this.vm.info = this.angularFilterHelperService.translate('Siffi.Services_Intro_4')
					.replace('%s', startTime).replace('%e', endTime);
			} else {
				if (weekendStartTime && weekendEndTime) {
					this.vm.info = this.angularFilterHelperService.translate('Siffi.Services_Intro_4_Weekends')
						.replace('%s', startTime).replace('%e', endTime)
						.replace('%ws', weekendStartTime).replace('%we', weekendEndTime);
				} else {
					this.vm.info = this.angularFilterHelperService.translate('Siffi.Services_Intro_4')
						.replace('%s', startTime).replace('%e', endTime);
				}
			}
		} else {
			if (this.vm.settings.workingDaysOnly) {
				this.vm.info = this.angularFilterHelperService.translate('Booking.Instant.Info_Weekdays')
					.replace('%s', startTime).replace('%e', endTime) + timeZoneInfo;
			} else {
				if (weekendStartTime && weekendEndTime) {
					this.vm.info = this.angularFilterHelperService.translate('Booking.Instant.Info_Weekend_Restricted')
						.replace('%s', startTime).replace('%e', endTime)
						.replace('%ws', weekendStartTime).replace('%we', weekendEndTime) + timeZoneInfo;
				} else {
					this.vm.info = this.angularFilterHelperService.translate('Booking.Instant.Info_Default')
						.replace('%s', startTime).replace('%e', endTime) + timeZoneInfo;
				}
			}
		}
	}
	
	goToConciergeFlow() {
		if (this.vm.mentalHealthCheckLoading) {
			return;
		}
		this.vm.mentalHealthCheckLoading = true;
		this.vm.isProcessing = true;
		var params: any = {
			origin: this.vm.origin
		};
		this.serviceRestServices.getMentalHealthServiceStatus(params, (statusResult) => {
			this.vm.mentalHealthCheckLoading = false;
			if (statusResult && statusResult.status === 'ACTIVE') {
				if (statusResult.isPreVisitCustomer) {
					this.angularRoutingHelperService.setPath("/pre-visit/mental-check");
				} else {
					this.angularRoutingHelperService.clearQueryParamsDirty()
					this.angularRoutingHelperService.setPath('/booking/mental-check', false, false, { step: 'CONSULTANT' });
				}
			} else {
				this.angularRoutingHelperService.setPath("/booking/mental-check-unavailable");
			}
		});
	}
	
	goToFollowUpHistory() {
		this.angularRoutingHelperService.setPath('/history');
	}
	
	goToMyWellbeingProfile() {
		this.angularRoutingHelperService.setPath('/my/wellbeing/profile');
	}
	
	goToMeditationActivation() {
		this.angularRoutingHelperService.setPath('/meditation');
	}
	
	goToAudiobooks() {
		this.angularRoutingHelperService.setPath('/audiobooks');
	}
	
}